import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBTable, MDBTableBody, MDBTableHead, MDBIcon, MDBDataTable } from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Descriptions   } from 'antd';
import { api, URL } from '../../api';
import Swal from 'sweetalert2/dist/sweetalert2.js'

import ReactExport from "react-export-excel";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


export default class Modelshowstudentshort extends Component {


    constructor(props) {
              super(props);
      this.state = {
        modal: false,
       
        Curriculumopen_Full_Name_TH:'',
        Curriculumopen_Full_Name_EN:'',
        Curriculumopen_CH:'',

        Curriculumopen_ID:'',
        Studentcb_ID:'',
        Citizen:'',

        studentlist:[],

        Shortcoursemd_Nameshort_TH:'',
        
      }

this.handleSubmit = this.handleSubmit.bind(this);
this.getregisterCurriculum = this.getregisterCurriculum.bind(this);

}


            toggle = () => {
                this.setState({
                modal: !this.state.modal
                });
                this.setState({ Citizen:this.props.Citizen})
               // this.getregisterCurriculum();
            }

            getregisterCurriculum() {
                setTimeout(() => {
                   //ภายใน
                   api.get('index/getregisterCurriculum/'+this.props.Curriculumopen_ID)
                   .then(res => {
                   //  console.log(res.data);
                     const Numlist = res.data.filter( ({ Studentcb_Citizen_ID }) => Studentcb_Citizen_ID === this.props.Citizen );
                   //  this.setState({ bankname: res.data, loading: false })
                     this.setState({ Numlist : Numlist})
                   }) 
                 }, 0);
            }


            handleSubmit() {
                // alert('A name was submitted: ' + this.state.value);
               setTimeout(() => {           
                  const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                  datafrm.append("Curriculumopen_ID", this.state.Curriculumopen_ID);
                  datafrm.append("Studentcb_ID", this.state.Studentcb_ID);
                  datafrm.append("Studentcb_Citizen_ID", this.state.Citizen);
                  
                  api.post("index/AddregisterCurriculum/",datafrm,{
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                   })
            
               .then(res => {
                //    console.log(res);
                    if (res.status === 200) {
                    //  alert("บันทึกสำเร็จ")
                              Swal.fire({
                                  title: 'ลงทะเบียนสำเร็จ',
                                  icon: 'success',
                                // showCancelButton: true,
                                  confirmButtonText: 'ตกลง',
                                // cancelButtonText: 'No, keep it'
                                }).then((result) => {
                                
                                })
                             }
                    })

                    this.getregisterCurriculum();
                   // this.toggle()
                  //  this.props.getclassroom()
            }, 1000);
            
            //window.location.href = '/Curriculum'
            //this.props.updateat();
            //this.getExpert()
             
              }




            componentDidMount() {

                //const { id_send } = this.props.id_send
                //console.log(this.props.Curriculumopen_ID);
                this.setState({ Curriculumopen_ID:this.props.Curriculumopen_ID}) 
                
                this.setState({ Shortcoursemd_Nameshort_TH:this.props.Shortcoursemd_Nameshort_TH}) 
               // this.setState({ Curriculumopen_Full_Name_TH:this.props.Curriculumopen_Full_Name_TH})
               // this.setState({ Citizen:this.props.Citizen})
                this.setState({ Shortcoursemd_ID:this.props.Shortcoursemd_ID}) 
              
                          api.get('index/getCurriculumstudentlistshort/'+this.props.Shortcoursemd_ID,
                          //  Axios.get(`https://git.kpru.ac.th/FrontEnd_creditbank/index/getteacheruniv/`+localStorage.getItem('Univ_ID'),
                          //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                          {headers: {
                          // Authorization: 'Bearer ' + localStorage.getItem('myData')
                          }
                          })
                          //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                          .then(res => {
                          // console.log(res.data[0].id)
                          //  console.log(res.data)
                          //  const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                          //  console.log(Course)
                     
                              const studentlist = res.data;
                              this.setState({ studentlist });
                           }) 
             //  this.getteacherforcurriculum();
                }


    render() {
       // console.log(this.state.Numlist.length)

       const datast = {
        columns: [
          {
            label: '#',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'ชื่อ',
            field: 'Studentcb_NAME',
            sort: 'Studentcb_NAME',
            width: 150
          },
          {
            label: 'นามสกุล',
            field: 'Studentcb_LASTNAME',
            sort: 'Studentcb_LASTNAME',
            width: 270
          },
          {
            label: 'เบอร์โทร',
            field: 'Studentcb_TEL',
            sort: 'Studentcb_TEL',
            width: 200
          },
          {
            label: 'อีเมลล์',
            field: 'Studentcb_EMAIL',
            sort: 'Studentcb_EMAIL',
            width: 100
          }
        ],
  
        rows: [...this.state.studentlist.map((data, i) => (
          {
             list: <>{i+1}</>,
             Studentcb_NAME: <>{data.FULLNAME}{data.Studentcb_NAME}</>,
             Studentcb_LASTNAME: <>{data.Studentcb_LASTNAME}</>,
             Studentcb_TEL: <>{data.Studentcb_TEL}</>,
             Studentcb_EMAIL: <>{data.Studentcb_EMAIL}</>,
           
            
            random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,
            
          }
         ))]
        
    
        };
  
            const persons = <MDBDataTable
            // searching ={true} 
            searchLabel="ค้นหาชื่อ"
            striped
            bordered
            small 
            entries={20}
            // entriesOptions={["10", "20"]}
            order={["age", "desc"]}
            data={datast}
            entriesLabel="จำนวนที่แสดง "
            infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
            paginationLabel={["ย้อนกลับ", "ถัดไป"]}
            responsive 
            sortRows={['random']}
            />


        return (
            <>
               
                    <MDBBtn onClick={this.toggle} color="primary" size='sm'>รายชื่อผู้ลงทะเบียน</MDBBtn>

                    <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
                    <MDBModalHeader toggle={this.toggle}><MDBIcon icon="list-alt" /> รายชื่อการลงทะเบียน </MDBModalHeader>
                   
                        <MDBModalBody>
                            {/* {this.props.Citizen} */}
                             <h5>หลักสูตร {this.state.Shortcoursemd_Nameshort_TH}</h5>  

                             {/* <MDBTable>
                                <MDBTableHead>
                                    <tr>
                                    <th>ลำดับ</th>
                                    <th>ชื่อ</th>
                                    <th>นามสกุล</th>
                                    <th>เบอร์โทร</th>
                                    <th>e-mail</th>
                                    </tr>
                                </MDBTableHead>
                                <MDBTableBody>
                                    {this.state.studentlist.map((studentlist,index) =>{ 
                                    return  <tr>
                                                <td>{index+1}</td>
                                                <td>{studentlist.FULLNAME}{studentlist.Studentcb_NAME}</td>
                                                <td>{studentlist.Studentcb_LASTNAME}</td>
                                                <td>{studentlist.Studentcb_TEL}</td>
                                                <td>{studentlist.Studentcb_EMAIL}</td>
                                            </tr>
                                    } )}
                                   
                                    
                                </MDBTableBody>
                             </MDBTable> */}
                             
                             {/* <ExcelFile filename={this.state.Curriculumopen_Full_Name_TH} element={<Button size="small">  &nbsp; <MDBIcon icon="file-excel" />&nbsp; EXPORT EXCEl </Button>}>
                                  <ExcelSheet data={this.state.studentlist} name="รายชื่อผู้เรียน">
                                    
                                      <ExcelColumn label="คำนำหน้า" style={{ rgb: "009900" }} value="FULLNAME" />
                                      <ExcelColumn label="ชื่อ" style={{ rgb: "009900" }} value="Studentcb_NAME" />
                                      <ExcelColumn label="นามสกุล" value="Studentcb_LASTNAME" />
                                      <ExcelColumn label="เบอร์โทร" value="Studentcb_TEL" />
                                      <ExcelColumn label="อีเมลล์" value="Studentcb_EMAIL" />
                                      
                                  </ExcelSheet>
                            </ExcelFile> */}


                                 <ExcelFile filename={this.state.Shortcoursemd_Nameshort_TH} element={<Button size="small">  &nbsp; <MDBIcon icon="file-excel" />&nbsp; EXPORT EXCEl </Button>}>
                                                              <ExcelSheet data={this.state.studentlist} name="รายชื่อผู้เรียน">
                                                                
                                                                  <ExcelColumn label="คำนำหน้า" style={{ rgb: "009900" }} value="FULLNAME" />
                                                                  <ExcelColumn label="ชื่อ" style={{ rgb: "009900" }} value="Studentcb_NAME" />
                                                                  <ExcelColumn label="นามสกุล" value="Studentcb_LASTNAME" />
                                                                  <ExcelColumn label="เบอร์โทร" value="Studentcb_TEL" />
                                                                  <ExcelColumn label="อีเมลล์" value="Studentcb_EMAIL" />
                                                                  
                                                              </ExcelSheet>
                                   </ExcelFile>



                              {persons}
                                    
                           
                             
                        </MDBModalBody>
                        <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                        {/* <MDBBtn color="primary">Save changes</MDBBtn> */}
                        </MDBModalFooter>
                    </MDBModal>
               
            </>
        )
    }
}
